<template>
  <div class="block-label">
    {{ label }}
  </div>
</template>
<script>
export default {
  props: ['label'],
}
</script>
<style scoped>
.block-label {
  width: 100%;
  font-weight: 500;
  background-color: rgba(128, 128, 128, 0.5);
  padding: 5px;
}
</style>
